import { createReducer } from 'typesafe-actions';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { getHelpCenterArticlesActions } from './actions';
import { HelpCenterState, HELP_CENTER_IDENTIFIER } from './types';

export const defaultState = {
    articles: [],
    isFetching: false,
    didInvalidate: false,
    identifier: '',
};

const configurationsReducer = createReducer<HelpCenterState>(defaultState)
    .handleAction(getHelpCenterArticlesActions.actions.success, (state, action) => {
        const response = action.payload.data;
        if (response && response.data) {
            return {
                ...state,
                articles: response.data,
                isFetching: false,
                identifier: HELP_CENTER_IDENTIFIER,
            };
        }
        return {
            ...state,
            isFetching: false,
        };
    })
    .handleAction(getHelpCenterArticlesActions.actions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(getHelpCenterArticlesActions.actions.request, (state, action) =>
        defaultRequestHandler(state, action)
    );

export default configurationsReducer;
